'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};



//////////////////
// WEBPACK FOOTER
// ./~/_axios@0.15.3@axios/lib/cancel/isCancel.js
// module id = 50
// module chunks = 0